module.exports = __webpack_public_path__ + "assets/0ac42c11953a5e0e0b62c14531a3fa6a.png";